import React from "react";

function Firefox() {
  return (
    <div>
      <h3>Enabling Safari Location Services (Firefox)</h3>
      <p>
        You can inspect and manage the permissions for the domain in the
        currently selected tab via these steps:
      </p>
      <ol>
        <li>
          Click the "Site Identity Button" (globe/padlock) on the location bar
        </li>
        <li>
          Click "More Information" to open "Tools &gt; Page Info" with the
          Security tab selected
        </li>
        <li>
          Go to the Permissions tab (Tools &gt; Page Info &gt; Permissions) to
          check the permissions for the domain in the currently selected tab
        </li>
      </ol>
      <p>
        You can inspect and manage the permissions for all domains on the&nbsp;
        <strong>about:permissions</strong>&nbsp;page.
      </p>
    </div>
  );
}

export default Firefox;
